import { INIT_FILTER_REQUEST, initFilterSuccess } from "ducks/filter";

export const initFilterEpic = (action$, store, { filterSelectors }) =>
  action$
    .ofType(INIT_FILTER_REQUEST)
    .filter(action => filterSelectors.shouldInitFilter(store.getState()))
    .mergeMap(({ payload: { filterId, thingType } }) => [
      initFilterSuccess({ filterId, thingType })
    ]);
